import { ICartDictionary, IProduct } from '@engyalo/storefront-types/lib/plugins/model'
import { generateCartId } from '../lib/cartIdGenerator'
import { getTotalPrice } from '../lib/getTotalPrice'

export const getPreloadedCart = (
  cart: ICartDictionary,
  product: IProduct,
  quantity: number,
  shouldReplace = false,
  cartId: string | null = null
): ICartDictionary => {
  const tempCart = { ...cart }
  if (product && product.id) {
    const currentSku = cartId || generateCartId(product)
    if (tempCart[currentSku]) {
      const tempProd = { ...tempCart[currentSku] }
      if (tempProd.quantity) {
        const totalPrice = getTotalPrice(product)
        tempProd.quantity = shouldReplace ? quantity : tempProd.quantity + quantity
        if (tempProd.quantity > 0) {
          tempCart[currentSku] = {
            ...tempProd,
            totalPrice,
          }
        } else {
          delete tempCart[currentSku]
        }
      }
    } else if (quantity > 0) {
      const totalPrice = getTotalPrice(product)
      tempCart[currentSku] = {
        ...product,
        totalPrice,
        quantity,
        cartId: currentSku,
      } as IProduct
    }
  }
  return tempCart
}
